import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import AdminSubpageHeader from 'features/admin/admin-subpage-header';
import { Routes } from 'enums';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import AutomationsTab from './tabs/automations-tab';
import CustomersTab from './tabs/customers-tab';
import GrowthTab from './tabs/growth-tab';
import InsightsTab from './tabs/insights-tab';
import MessagesTab from './tabs/messages-tab';
import PromotionsTab from './tabs/promotions-tab';
import RetentionTab from './tabs/retention-tab';
import RevenueTab from './tabs/revenue-tab';
import SettingsTab from './tabs/settings-tab';
import TemplatesTab from './tabs/templates-tab';
import { ENGAGEMENT_TABS, resolveEngagementTab, type EngagementTabSlug } from './engagement-logic';

const TAB_COMPONENTS: Record<EngagementTabSlug, React.FC> = {
  kunden: CustomersTab,
  nachrichten: MessagesTab,
  vorlagen: TemplatesTab,
  automationen: AutomationsTab,
  aktionen: PromotionsTab,
  wachstum: GrowthTab,
  umsatz: RevenueTab,
  bindung: RetentionTab,
  wirkung: InsightsTab,
  einstellungen: SettingsTab,
};

const EngagementCenter: React.FC<{ initialTab?: EngagementTabSlug }> = ({ initialTab }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tab: tabParam } = useParams<{ tab?: string }>();
  const active = initialTab ?? resolveEngagementTab(tabParam);
  const Active = TAB_COMPONENTS[active];

  return (
    <Box sx={{ p: { xs: '20px 16px 24px', lg: '32px 48px 48px' } }}>
      <AdminSubpageHeader title={t('engCenterTitle')} showTitle />
      <Typography sx={{ fontSize: 14, color: 'text.secondary', mt: 0.5, mb: 2 }}>{t('engCenterSubtitle')}</Typography>
      <Tabs
        value={active}
        onChange={(_, v: EngagementTabSlug) => navigate(`${Routes.ADMIN_ENGAGEMENT}/${v}`)}
        variant={'scrollable'}
        scrollButtons={'auto'}
        sx={{ borderBottom: 1, borderColor: 'greys.lighter', mb: 2.5 }}
      >
        {ENGAGEMENT_TABS.map((slug) => (
          <Tab key={slug} value={slug} label={t(`engTab_${slug}`)} sx={{ textTransform: 'none', fontSize: 14 }} />
        ))}
      </Tabs>
      <Stack>
        <Active />
      </Stack>
    </Box>
  );
};

export default EngagementCenter;
